import { Transforms, Editor } from 'slate';
import { isMediaElement } from '../types/guards';

class AttachmentUtils {
  static removeBySrc(editor, src) {
    Transforms.removeNodes(editor, {
      at: {
        anchor: Editor.start(editor, []),
        focus: Editor.end(editor, []),
      },
      match: (element) =>
        isMediaElement(element) && element.media_src.includes(src),
      mode: 'lowest',
      voids: true,
    });
  }
}

export default AttachmentUtils;
